<template>
  <div class="section">
    <div
      class="inner"
      :style="{ background: '#fff url(' + images.bg + ') left top no-repeat' }"
    >
      <div style="margin-left: 50px; padding-top: 60px">
        <img :src="images.title" style="height: auto; width: 35%" />
      </div>
      <div style="padding: 40px 40px 0px 40px">
        <p style="text-indent: 40px; line-height: 30px">
          {{ content1 }}
        </p>
      </div>
      <div style="text-align: center">
        <lowHighScore :result="this.result" :level2="this.level2" />
      </div>

      <div class="summarize">
        <div style="padding: 70px 30px 30px 40px">
          从心理状态剖面图可以看出，测试者现阶段：
        </div>

        <!------------------ 良好 -------------------------------->
        <div style="padding: 0px 30px 10px 40px">
          <img :src="images.good" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            状态比较良好的特征
          </p>
        </div>

        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.good.length != 0"
        >
          <div
            v-for="(item, index) in this.good"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != good.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。</span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.good.length == 0">无</div>
        <!------------------ 较差 -------------------------------->
        <div style="padding: 20px 30px 10px 40px">
          <img :src="images.jiaocha" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            状态较差的特征
          </p>
        </div>

        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.jiaocha.length != 0"
        >
          <div
            v-for="(item, index) in this.jiaocha"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != jiaocha.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。 </span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.jiaocha.length == 0">无</div>

        <!------------------ 差不多 -------------------------------->
        <div style="padding: 20px 30px 10px 40px">
          <img :src="images.chabuduo" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            与多数人状态差不多的特征
          </p>
        </div>
        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.chabuduo.length != 0"
        >
          <div
            v-for="(item, index) in this.chabuduo"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != chabuduo.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。 </span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.chabuduo.length == 0">
          无
        </div>

        <div class="fixpage-bg">
          <img :src="images.paback" />
          <!-- <div style="text-align: center;margin-top:300px;margin-left:185px">
            <img :src="images.page6" style="height:auto%;width:6%;" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageFour } from "@/views/report/config/three";
import lowHighScore from "@/components/dataView/table/three/lowHighScore.vue";
export default {
  props: ["result", "level2", "score1"],
  components: { lowHighScore },
  data() {
    return {
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
        bg: require("../../../assets/images/page7/bg.png"),
        page: require("../../../assets/images/page7/page.png"),
        title: require("../../../assets/images/page7/title.png"),
        page: require("../../../assets/images/page7/page.png"),
        good: require("../../../assets/images/page7/good.png"),
        chabuduo: require("../../../assets/images/page7/chabuduo.png"),
        jiaocha: require("../../../assets/images/page7/jiaocha.png"),
        paback: require("../../../assets/images/page7/paback.png"),
        page6: require("../../../assets/images/page7/page6.png"),
      },
      chabuduo: [], // 4-7 分
      jiaocha: [], // 1-3 分
      good: [], // 8-10 分
      value: {}, //监控数据
      content1: pageFour.content1,
      SectionviewData: pageFour.SectionviewData,
    };
  },
  watch: {
    level2(val) {
      this.level2 = val;
      this.panduan();
    },
  },
  methods: {
    panduan() {
      this.level2.map((item) => {
        if (
          (item.score > 3.33 || item.score == 3.33) &&
          (item.score < 3.83 || item.score == 3.83)
        ) {
          // this.realScore.push(1);
          item.score = 1;
        } else if (
          (item.score > 3.84 || item.score == 3.84) &&
          (item.score < 4.25 || item.score == 4.25)
        ) {
          item.score = 2;
          // return (item.score = 2);
          // this.realScore.push(2);
        } else if (
          (item.score > 4.26 || item.score == 4.26) &&
          (item.score < 4.99 || item.score == 4.99)
        ) {
          // return (item.score = 3);
          // this.realScore.push(3);
          item.score = 3;
        } else if (
          (item.score > 5 || item.score == 5) &&
          (item.score < 6 || item.score == 6)
        ) {
          // return (item.score = 4);
          // this.realScore.push(4);
          item.score = 4;
        } else if (
          (item.score > 6.01 || item.score == 6.01) &&
          (item.score < 6.61 || item.score == 6.61)
        ) {
          // return (item.score = 5);
          // this.realScore.push(5);
          item.score = 5;
        } else if (
          (item.score > 6.62 || item.score == 6.62) &&
          (item.score < 7.24 || item.score == 7.24)
        ) {
          // return (item.score = 6);
          // this.realScore.push(6);
          item.score = 6;
        } else if (
          (item.score > 7.25 || item.score == 7.25) &&
          (item.score < 8.32 || item.score == 8.32)
        ) {
          // return (item.score = 7);
          // this.realScore.push(7);
          item.score = 7;
        } else if (
          (item.score > 8.33 || item.score == 8.33) &&
          (item.score < 9.07 || item.score == 9.07)
        ) {
          // return (item.score = 8);
          // this.realScore.push(8);
          item.score = 8;
        } else if (
          (item.score > 9.08 || item.score == 9.08) &&
          (item.score < 9.49 || item.score == 9.49)
        ) {
          // return (item.score = 9);
          // this.realScore.push(9);
          item.score = 9;
        } else if (
          (item.score > 9.5 || item.score == 9.5) &&
          (item.score < 10 || item.score == 10)
        ) {
          // return (item.score = 10);
          // this.realScore.push(10);
          item.score = 10;
        }
        // console.log("真实分数", item.score);

        if (
          item.score == 0 ||
          item.score == 1 ||
          item.score == 2 ||
          item.score == 3
        ) {
          this.jiaocha.push({
            name: item.name,
            score: item.score,
          });
        } else if (
          item.score == 4 ||
          item.score == 5 ||
          item.score == 6 ||
          item.score == 7
        ) {
          this.chabuduo.push({
            name: item.name,
            score: item.score,
          });
        } else {
          this.good.push({
            name: item.name,
            score: item.score,
          });
        }
      });
      // console.log("this.jiaocha", this.jiaocha);
      // console.log("this.chabuduo", this.chabuduo);
      // console.log("this.good", this.good);
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  // height: 1124px; //A4纸的高度像素
  page-break-inside: avoid;
}
.inner {
  position: relative;
  background-size: 300px !important;
  background-repeat: no-repeat;
}

.summarize {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px;
  position: relative;
}
.fixpage-bg {
  float: right;
  width: 100%;
  background-color: white;
  position: absolute;
  bottom: 0px;
}
.fixpage-bg img {
  height: auto;
  width: 25%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageSix.vue